define.alias("shared/components/shared/address-fields", "settings/components/shared/address-fields");